import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import STCommentItem from "../../../../assets/styles/organisms/myPageCommentItem.module.scss";
import BoardActions from "./BoardActions";
import { useGetTabUUID } from "../../comments/hooks";
import { putBoardComment } from "../../../../utils/api/putComment";
import { UpdateCommentRequest } from "../../../../api/board_comment";

const COMMENT_STATUS = {
  PENDING: 0,
  PUBLIC: 1,
  PRIVATE: 2,
  REJECTED: 3,
};

interface CommentItemProps {
  boardId: number;
  detailComment: {
    status: number;
    content: string;
    createdAt: string;
    id: number;
  };
  onUpdateSuccess: (newComment: any) => void;
  onDeleteSuccess: (deletedCommentId: number) => void;
}

const CommentItem: React.FC<CommentItemProps> = ({
  boardId,
  detailComment,
  onUpdateSuccess,
  onDeleteSuccess,
}) => {
  const deviceId = useGetTabUUID();
  const { status, content, createdAt, id } = detailComment;
  const [commentText, setCommentText] = React.useState(content);
  const [isEditMode, setIsEditMode] = React.useState(false);

  const generateStatus = (status: number) => {
    let text = "";
    let color = "";
    switch (status) {
      case COMMENT_STATUS.PENDING:
        text = "承認待ち";
        color = "#EF2628";
        break;
      case COMMENT_STATUS.PUBLIC:
        text = "公開中";
        color = "#222222";
        break;
      case COMMENT_STATUS.PRIVATE:
      case COMMENT_STATUS.REJECTED:
        text = "非公開";
        color = "#222222";
        break;
      default:
        break;
    }

    return (
      <div style={{ color: color }} className={STCommentItem.status}>
        {text}
      </div>
    );
  };
  const handleUpdate = async () => {
    const params: UpdateCommentRequest = {
      content: commentText,
      board_id: boardId,
      comment_id: Number(id),
      device_id: deviceId,
    };
    // Save the edited comment
    await putBoardComment(params)
      .then((response) => {
        const { isSuccess, result = {} } = response;
        if (!isSuccess) {
          throw new Error("");
        } else {
          const newComment = result?.data;
          onUpdateSuccess({
            id: newComment.id,
            content: commentText,
            status: newComment.status,
          });
        }
      })
      .catch((error) => {
        console.error("Error updating comment:", error);
        setCommentText(content);
      })
      .finally(() => {
        setIsEditMode(false);
      });
  };

  const handleDelete = () => {
    onDeleteSuccess(id);
  };
  return (
    <div
      className={STCommentItem.commentItem}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={STCommentItem.action}>
        {isEditMode ? (
          <div
            style={{
              fontSize: 15,
              display: "flex",
              alignItems: "center",
              gap: 4,
              marginTop: 4,
            }}
          >
            <CheckIcon
              fontSize="inherit"
              style={{ color: "#319131" }}
              onClick={handleUpdate}
            />
            <ClearIcon
              fontSize="inherit"
              style={{ color: "red" }}
              onClick={() => {
                setIsEditMode(false);
                setCommentText(content);
              }}
            />
          </div>
        ) : (
          <BoardActions
            targetId={id}
            onEdit={() => setIsEditMode(true)}
            onDelete={handleDelete}
          />
        )}
      </div>
      <div className={STCommentItem.header}>
        <span>{createdAt}</span>
        <div>{generateStatus(status)}</div>
      </div>
      {isEditMode ? (
        <textarea
          className={STCommentItem.textarea}
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
        />
      ) : (
        <div className={STCommentItem.detailComment}>{content}</div>
      )}
    </div>
  );
};

export default CommentItem;
